import React, { memo } from 'react';
import { Col, Container, Nav, Row, Tab } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';

// Components
import IconWithText from '../IconWithText/IconWithText';
import Buttons from '../Button/Buttons';

// Data
import { TabData07 } from './TabData';

const Tab07 = (props) => {
  const { t, i18n } = useTranslation(); // الوصول إلى الترجمات وإعدادات i18n
  const isRtl = i18n.language === 'ar'; // تحديد اتجاه النص

  // جلب البيانات المترجمة
  const data = TabData07(t);

  return (
    <Tab.Container id="left-tabs-example" defaultActiveKey={0}>
      <Row className="tab-style-07" style={{ direction: isRtl ? 'rtl' : 'ltr' }}>
        <Col lg={12} className="p-0 xs:!px-[15px]">
          <Nav className="justify-center uppercase font-serif font-medium text-center cursor-pointer border-b border-t border-solid border-mediumgray mb-40 md:flex-nowrap md:mb-[72px] sm:mb-[66px] sm:border-b-0">
            {data.map((item, i) => (
              <Nav.Item key={i}>
                <Nav.Link
                  className="block text-xxl text-darkgray border-b-[3px] border-solid border-transparent py-[30px] px-[40px] mb-0"
                  eventKey={i}
                  style={{ textAlign: isRtl ? 'right' : 'left' }}
                >
                  {item.tabTitle}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </Col>
        <Col lg={12} className="p-0 xs:!px-[15px]">
          <Container>
            <Col>
              <Tab.Content>
                {data.map((item, i) => (
                  <Tab.Pane eventKey={i} key={i}>
                    <Row className="items-center">
                      <Col
                        md={6}
                        className="tab-data items-center landscape:px-[15px]"
                        style={{ textAlign: isRtl ? 'right' : 'left' }}
                      >
                        <div className={`relative ${isRtl ? 'mr-auto' : 'ml-auto'}`}>
                          {item.img && (
                            <img style={{ boxShadow: "20px 20px 20px rgba(0, 0, 0, 0.4)" }}
                              className="w-[80%]"
                              src={item.img}
                              alt={t('tab07.image_alt', { tab: item.tabTitle })}
                            />
                          )}
                          {item.tabTitle && (
                            <div style={{ boxShadow: "20px 20px 20px rgba(0, 0, 0, 0.4)" }}
                              className={`bg-gradient-to-tr from-[#bf8c4c] to-[#445a58] text-white font-serif text-xxl w-[190px] min-lg:w-[270px] absolute top-[5px] font-bold ${isRtl ? 'right-[-15px]' : 'left-[-15px]'} py-2 px-14 lg:text-lg min-md:w-[250px] min-md:p-[24px] mi,-md:${isRtl ? 'right-[-15px]' : 'left-[-15px]'} min-md:leading-[26px]`}
                            >
                              {item.tabTitle}
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col
                        className="content landscape:px-[15px]"
                        lg={{ span: 4, offset: 1 }}
                        md={4}
                        style={{ textAlign: isRtl ? 'right' : 'left' }}
                      >
                        {item.description && (
                          <p className="text-blue-700 text-xxl my-8">{item.description}</p>
                        )}
                      </Col>
                    </Row>
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Col>
          </Container>
        </Col>
      </Row>
    </Tab.Container>
  );
};

Tab07.defaultProps = {
  data: TabData07,
};

Tab07.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.exact({
      tabTitle: PropTypes.string,
      subtitle: PropTypes.string,
      title: PropTypes.string,
      img: PropTypes.string,
      content: PropTypes.string,
      buttonLink: PropTypes.string,
      buttonTitle: PropTypes.string,
      tabicons: PropTypes.string,
      description: PropTypes.string, // Ajout de la propriété description
      day: PropTypes.string,
      activities: PropTypes.arrayOf(
        PropTypes.exact({
          time: PropTypes.string,
          content: PropTypes.string,
          title: PropTypes.string,
          img: PropTypes.string,
          author: PropTypes.string,
        })
      ),
      featurebox: PropTypes.arrayOf(
        PropTypes.exact({
          content: PropTypes.string,
          title: PropTypes.string,
          icon: PropTypes.string,
        })
      ),
    })
  ),
};

export default memo(Tab07);